/* 22B2 - Widget regalo V1.4.0: recupero drawer + nascondi dopo qualifica. */
(() => {
  'use strict';

  const template = document.getElementById('BdGiftDrawerTemplate');
  const source = template?.content?.querySelector('[data-bd-gift-widget="drawer"]');
  if (!source) return;

  const placement = template.dataset.placement === 'after_actions' ? 'after_actions' : 'before_actions';
  const selector = '[data-bd-gift-widget="drawer"]';
  let currentDrawer = null;
  let observer = null;
  let scheduled = false;
  let lastOpen = null;

  function ensureDrawerGift() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    // The native snippet is rendered only for a non-empty cart.
    const container = drawer.querySelector('.cart-drawer__summary__container');
    if (!container) return;

    const existing = container.querySelector(selector);
    // Marker updated by the AJAX-rendered summary. Never re-inject an invitation
    // once a qualifying Magazzino Italia product is present in the cart.
    if (container.dataset.bdGiftQualified === 'true') {
      if (existing) existing.remove();
      return;
    }
    if (existing) {
      // Keep the customer's collapsed/expanded choice through AJAX refreshes.
      if (lastOpen !== null && existing.open !== lastOpen) existing.open = lastOpen;
      return;
    }

    const gift = source.cloneNode(true);
    if (lastOpen !== null) gift.open = lastOpen;
    const actions = container.querySelector('.cart-drawer__actions');

    if (placement === 'after_actions' && actions) {
      actions.insertAdjacentElement('afterend', gift);
    } else {
      // Match the Liquid placement beneath shipping information, before checkout.
      const shipping = container.querySelector('.cart-drawer__calculate-shipping');
      if (shipping) shipping.insertAdjacentElement('afterend', gift);
      else if (actions) actions.insertAdjacentElement('beforebegin', gift);
      else container.appendChild(gift);
    }
  }

  function scheduleCheck() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      ensureDrawerGift();
    });
  }

  function attachObserver() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    if (drawer !== currentDrawer) {
      observer?.disconnect();
      currentDrawer = drawer;
      observer = new MutationObserver(scheduleCheck);
      observer.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-bd-gift-qualified'] });
    }
    scheduleCheck();
  }

  // 'toggle' does not bubble: capture it on the drawer to remember the UI state.
  document.addEventListener('toggle', (event) => {
    const target = event.target;
    if (target?.matches?.(selector) && target.closest('#CartDrawer')) {
      lastOpen = target.open;
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver, { once: true });
  } else {
    attachObserver();
  }

  document.addEventListener('cart:minicart:open', attachObserver);
  document.addEventListener('shopify:section:load', attachObserver);
})();
